import { HttpContextToken, HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { MessageService } from 'primeng/api';
import { tap } from 'rxjs';

/** Set to true on a request's HttpContext to suppress the automatic success toast. */
export const SKIP_SUCCESS_TOAST = new HttpContextToken<boolean>(() => false);

export const toastInterceptor: HttpInterceptorFn = (req, next) => {
  const messageService = inject(MessageService);
  const methodsToShowToast = ['POST', 'PUT', 'PATCH', 'DELETE'];
  const successStatusCodes = [200, 201];

  return next(req).pipe(
    tap(event => {
      if (req.url.includes('/auth/refresh') || req.context.get(SKIP_SUCCESS_TOAST)) {
        return;
      }

      if (
        event instanceof HttpResponse &&
        successStatusCodes.includes(event.status) &&
        methodsToShowToast.includes(req.method.toUpperCase())
      ) {
        const body = event.body as { success?: boolean; message?: string } | null;
        if (body && body.success === true) {
          const message = body.message;
          messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: message,
            life: 4000
          });
        }
      }
    })
  );
};
